import { Injectable } from "@angular/core";
import { ChecklistNode } from "../../buildings/checklists/checklist/model/checklist-node";

@Injectable()
export class SessionStorageService {

  constructor() {}

  public setNodeExpandedStatus(value: ChecklistNode) {
    sessionStorage.setItem(value.id.toString(), JSON.stringify(value.expanded));
  }

  public getNodeExpandedStatus(id: number): boolean {
      return JSON.parse(sessionStorage.getItem(id.toString())) as boolean;
  }
}
